import { Stack, useTheme } from '@mui/material';
import { StackProps } from '@mui/material/Stack/Stack';
import { useIsMobile } from '@vayufp/coast-components';
import { FC, ReactNode } from 'react';

import CarImage from './CarImage.svg';
import { CostSavingsTestimonialCard, TimeSavingsTestimonialCard } from './TestimonialCard';
import { TestimonialHeading } from './TestimonialHeading';

type TestimonialKey = 'cost-savings' | 'time-savings';
type TestimonialData = {
  header: string;
  card: ReactNode;
};
type Testimonials = Record<TestimonialKey, TestimonialData>;
type TestimonialSectionProps = { data: TestimonialData };
type TestimonialPanelProps = {
  testimonialKey: TestimonialKey;
};

const testimonials: Testimonials = {
  'cost-savings': {
    header: 'Join thousands of happy customers who made the switch',
    card: <CostSavingsTestimonialCard />,
  },
  'time-savings': {
    header: 'Trusted by thousands of fleets who’ve already made the switch',
    card: <TimeSavingsTestimonialCard />,
  },
};

const TestimonialSection: FC<TestimonialSectionProps> = ({ data }) => {
  const { spacing } = useTheme();
  const { header, card } = data;
  return (
    <Stack width="100%" px={spacing(7)} gap={spacing(7)} justifyContent="center" alignItems="center">
      <TestimonialHeading header={header} />
      {card}
    </Stack>
  );
};

const TestimonialPanel: FC<TestimonialPanelProps> = ({ testimonialKey }) => {
  const { spacing } = useTheme();
  const isMobile = useIsMobile();
  const sizeProps: StackProps = isMobile
    ? { width: '100%' }
    : { minHeight: '100vh', position: 'sticky', maxWidth: spacing(66) };
  const testimonialData = testimonials[testimonialKey];

  return (
    <Stack
      {...sizeProps}
      gap={spacing(23.5)}
      sx={{ background: 'linear-gradient(180deg, rgba(123, 219, 247, 0.42) 0%, rgba(229, 249, 255, 0.70) 100%);' }}
      justifyContent="space-around"
      pt={spacing(18.25)}
      pb={spacing(12)}
    >
      <TestimonialSection data={testimonialData} />
      {!isMobile && <img style={{ paddingRight: spacing(2) }} alt="CarImage" src={CarImage} />}
    </Stack>
  );
};

export { TestimonialPanel };
